import React from 'react';
import {
  BrowserRouter as Router,
  Navigate,
  Routes,
  Route,
  useParams,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import CanopyLabsModelReleases from './blogs/CanopyLabsModelReleases';
import Mission from './Mission';
import Header from './Header';
import JobsPage from './JobsPage';
import Releases from './Releases';
import JobDescription from './JobDescription';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import './posthog'; // Import PostHog configuration (no need to assign it to a variable)

// A header wrapper that uses the location to determine the current page
const HeaderWithLocation = () => {
  const location = useLocation();

  const getCurrentPage = (path) => {
    if (path === '/model-releases') return 'releases/towards_human_sounding_tts';
    if (path === '/open-positions' || path.startsWith('/open-positions/'))
      return 'open-positions';
    if (path === '/our-mission') return 'our-mission';
    if (path.includes('release'))
      return 'releases';
    
  };

  return <Header currentPage={getCurrentPage(location.pathname)} />;
};

// Wrapper to extract releaseId from params
const CanopyLabsModelReleasesWithParams = ({
  releaseIdName = null,
}) => {
  const { releaseId } =  useParams();

  const chosedReleaseId = releaseIdName || releaseId;

  console.log("selecting", chosedReleaseId);
  return <CanopyLabsModelReleases releaseId={chosedReleaseId} />;
};

// Wrapper for JobsPage that passes a navigate handler
const JobsPageWithNavigate = () => {
  const navigate = useNavigate();
  const handleNavigate = (path) => navigate(path);
  return <JobsPage handleNavigate={handleNavigate} />;
};

// Wrapper for JobDescription that extracts jobId from params and passes a navigate handler
const JobDescriptionWithParams = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const handleNavigate = (path) => navigate(path);
  return <JobDescription jobId={jobId} handleNavigate={handleNavigate} />;
};

const App = () => {
  return (
    <PostHogProvider client={posthog}>
      <Router>
        <div className="flex flex-col min-h-screen font-sans text-gray-900">
          <HeaderWithLocation />
          <Routes>
            <Route path="/model-releases" element={<CanopyLabsModelReleasesWithParams
              releaseIdName="towards_human_sounding_tts"
            />} />
            <Route path="/releases/:releaseId" element={<CanopyLabsModelReleasesWithParams 
               />} />
            <Route path="/multilingual-research-release" element={<Navigate to="/releases/orpheus_can_speak_any_language" replace />} />

            <Route path="/open-positions" element={<JobsPageWithNavigate />} />
            <Route path="/releases" element={<Releases />} />
            <Route path="/open-positions/:jobId" element={<JobDescriptionWithParams />} />
            <Route path="/our-mission" element={<Mission />} />
            {/* Fallback route */}
            <Route path="*" element={<Mission />} />
          </Routes>
        </div>
      </Router>
    </PostHogProvider>
  );
};

export default App;
